import React from "react";
import { Button, Modal } from "antd";
import { BsExclamationTriangleFill } from "react-icons/bs";

import "../../style/modules/confirmationModal.scss";

const ConfirmationModal = ({
  width,
  open,
  title,
  message = 'Are you sure you want to proceed?',
  setOpen,
  onYes,
  loading,
}) => {
  const footerElem = [
    <div className="modal_footer">
      <Button key="submit" loading={loading ?? false} onClick={onYes}>
        Delete
      </Button>
      <Button key="back" onClick={() => setOpen(false)}>
        Cancel
      </Button>
    </div>,
  ];

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={handleCancel}
      footer={footerElem}
      width={width ?? 500}
    >

      <h2 className="confirmationModal">
        <BsExclamationTriangleFill
          size={30}
        />
        <p>
          {message}
        </p>
      </h2>

    </Modal>
  );
};

export default ConfirmationModal;
